import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=2756a05c&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=2756a05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756a05c",
  null
  
)

component.options.__file = "NewTag.vue"
export default component.exports